import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchAllCategories } from "../api/categories"; // Adjust path

const ShopDropdown = ({ closeMenu = () => {}, variant = "desktop" }) => {
  const [categories, setCategories] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const data = await fetchAllCategories();
        setCategories(data);
      } catch (err) {
        console.error("Failed to fetch categories", err);
      }
    };
    getCategories();
  }, []);

  if (variant === "mobile") {
    return (
      <div className="block">
        <button
          className="w-full text-left py-2 text-lg font-medium text-white/90 hover:text-cyan-400 transition-colors flex justify-between items-center"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          Shop
          <svg
            className={`w-5 h-5 transform transition-transform ${
              mobileOpen ? "rotate-180" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        {mobileOpen && (
          <div className="ml-4 mt-2 space-y-2">
            {categories.map((category) => (
              <Link
                key={category._id}
                to={`/products/category/${category.slug}`}
                className="block text-white/80 hover:text-cyan-400 transition-colors"
                onClick={closeMenu}
              >
                {category.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Desktop View
  return (
    <div className="relative group flex justify-center">
      <button className="relative text-sm font-medium text-white/80 hover:text-white transition-colors group tracking-wider px-4 py-2">
        Shop
        <span className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-cyan-400 group-hover:w-full transition-all duration-300"></span>
      </button>

      <div className="absolute left-1/2 transform -translate-x-1/2 top-full mt-3 w-48 rounded-xl bg-gradient-to-br from-[#0f0f0f] via-[#1a1a1a] to-black border border-cyan-500/30 shadow-lg shadow-cyan-500/30 backdrop-blur-lg opacity-0 group-hover:opacity-100 scale-90 group-hover:scale-100 transition-all origin-top duration-300 z-50">
        {categories.map((category) => (
          <Link
            key={category._id}
            to={`/products/category/${category.slug}`}
            onClick={closeMenu}
            className="block px-4 py-2 text-sm font-medium text-white hover:bg-cyan-500/10 hover:text-cyan-400 tracking-wide transition-all duration-200"
          >
            {category.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ShopDropdown;
